<mat-card>
  <mat-card-header>
    <mat-card-title>Búsqueda de Mis Gastos</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="canView">

      <mat-expansion-panel *ngIf="!isValidating">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="searchForm">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label>Fecha de Gasto Desde</mat-label>
                <input matInput [matDatepicker]="fechaGastoDesdePicker" formControlName="FechaGastoDesde"  (click)="fechaGastoDesdePicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaGastoDesdePicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaGastoDesde')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaGastoDesdePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Fecha de Gasto Hasta</mat-label>
                <input matInput [matDatepicker]="fechaGastoHastaPicker" formControlName="FechaGastoHasta"  (click)="fechaGastoHastaPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaGastoHastaPicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaGastoHasta')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaGastoHastaPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                <mat-select formControlName="ComunidadId">
                  <mat-option>Todas</mat-option>
                  <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label>Detalle</mat-label>
                <input matInput formControlName="Detalle" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionUf">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label>Código de UF</mat-label>
                <input matInput formControlName="UnidadFuncionalCodigo" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

          </div>

        </form>

      </mat-expansion-panel>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">
        <button mat-raised-button (click)="onSearch()" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
        <button mat-raised-button (click)="onExport()" [disabled]="isProcessing()" color="warn" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
      </div>

      <br/>

      <mat-expansion-panel [expanded]="false" [hideToggle]="false" class="zb-readonly" *ngIf="!isValidating">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <i class="fa fa-solid fa-chart-area fa-1x" style="margin-right: 5px;"></i> Estadísticas de la Búsqueda
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
              <mat-label><b>TOTALES:</b></mat-label>
              <br/>
              <mat-label *ngIf="isStatisticsSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
              <ng-container *ngIf="!isStatisticsSearching">
                <mat-label *ngFor="let item of totales | keyvalue" style="margin: 10px 0px 0px 10px;">
                  <b>{{item.key}}:</b> {{item.value | number: '1.2-2'}} <br/>
                </mat-label>
              </ng-container>
            </mat-expansion-panel>
          </div>

        </div>

      </mat-expansion-panel>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">
        <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
          [pageSettings]='pageSettings' [allowResizing]='true' (actionFailure)="onGridActionFailure($event)" (actionBegin)="onActionBegin($event)">
          <e-columns>
            <e-column field='FechaGasto' headerText='Fecha' width=90>
              <ng-template #template let-data>
                {{data.FechaGasto | date:'dd/MM/yyyy'}}
              </ng-template>
            </e-column>
            <e-column field='Comunidad' headerText='Comunidad' width=90>
              <ng-template #headerTemplate let-data>
                {{'Comunidad' | translate}}
              </ng-template>
            </e-column>
            <e-column field='UfCodigo' headerText='Cód. UF' width=90 *ngIf="tenantFeatureFlags?.HabilitarGestionUf"></e-column>
            <e-column field='TipoGasto' headerText='Tipo Gasto' width=90></e-column>
            <e-column field='ServicioGasto' headerText='Servicio' width=90 *ngIf="tenantFeatureFlags?.HabilitarControlExpensas"></e-column>
            <e-column field='Detalle' headerText='Detalle' width=90></e-column>
            <e-column field='Moneda' headerText='Moneda' width=90></e-column>
            <e-column field='Importe' headerText='Importe' width=90 format="N2"></e-column>
            <e-column field='AlicuotaIvaNombre' headerText='IVA' width=90></e-column>
            <e-column field='Liquidado' headerText='Liquidado' width=90 *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
              <ng-template #template let-data>
                {{data.Liquidado ? 'Sí' : 'No'}}
              </ng-template>
            </e-column>
            <e-column headerText='Acciones' width=90>
              <ng-template #template let-data>
                <a style="cursor: pointer; margin-right: 5px" (click)="edit(data)"><i class="fa fa-eye fa-1x"></i></a>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>

    </ng-container>

  </mat-card-content>
</mat-card>
